/**
 * @typedef StoreCache
 * @property {?object} data
 * @property {number} updatedTime milliseconds
 * @property {number} expireTime milliseconds
 * @property {boolean} autoRefresh
 */

/**
 * @typedef StoreData
 * @property {string} version
 * @property {Object.<string, StoreCache>} cache
 */

/**
 * @typedef StoreOption
 * @property {object} data
 * @property {number} validTime milliseconds
 * @property {boolean} autoRefresh
 */

class Store {
    pv = "1.0";
    storageKey = '__storedData';
    _init = false;
    /**
     * @type {StoreData}
     */
    _storedData = null;

    constructor(){
        this.init();
    }
    init() {
        if (!this._init) {
            this._storedData = JSON.parse(localStorage.getItem(this.storageKey));
        }

        //renew
        if (this._storedData == null || this.pv != this._storedData.version) {
            this._storedData = {
                version: this.pv,
                cache: {}
            };
        }

        this.save();
        this._init = true;
    }
    /**
     * @param {string} name
     */
    get(name){
        if (!(name in this._storedData.cache)) {
            return null;
        }

        const item = this._storedData.cache[name],
            now = new Date().getTime();

        //檢查過期
        if ((item.updatedTime + item.expireTime) < now) {
            return null;
        }

        //刷新時間
        if (item.autoRefresh) {
            item.updatedTime = now;
        }

        return item.data;
    }
    /**
     *
     * @param {string} name
     * @param {StoreOption} opt
     */
    set(name, opt) {
        if(typeof opt === "object" && opt !== null){
            this._storedData.cache[name] = {
                data: opt.data,
                updatedTime: new Date().getTime(),
                expireTime: opt.validTime || 1000 * 60 * 60 * 3, //有效小時
                autoRefresh: !!opt.autoRefresh
            };
        }else{
            delete this._storedData.cache[name];
        }
        this.save();
    }
    save(){
        localStorage.setItem(this.storageKey, JSON.stringify(this._storedData));
    }

    static Second(n){
        return 1000 * n;
    }
    static Minite(n){
        return Store.Second(n) * 60;
    }
    static Hour(n){
        return Store.Minite(n) * 60;
    }
    static Day(n){
        return Store.Hour(n) * 24;
    }
    static Month(n){
        return Store.Day(n) * 30;
    }
    static Year(n){
        return Store.Day(n) * 365;
    }
}
export default Store;